import React from 'react';
import FormSection from './FormSection';
import { buttonText } from '../common';

const Form = ({product, sections, fields}) => {
  let formSections = [];
  for (let [label, fieldOrder] of sections.entries()) {
    formSections.push(<FormSection key={label} label={label} fields={fields} fieldOrder={fieldOrder} />);
  }
  
  return (
    <form id="configurator">
      <div class="start-customizing">Start Customizing</div>
      <p>Questions? Click <a href="/contact/#quoteForm">here</a> to receive a free, no obligation quote</p>
      <ol>
        {formSections}
        <li>
          <button type="button" className="btn important" data-bs-toggle="modal" data-bs-target="#quoteForm">Quote this {buttonText(product.get('type'))}</button><em>Click to receive a free, no obligation quote</em>
        </li>
      </ol>
      <input name="product_id" type="hidden" value={product.get('id')}></input>
      <input name="product_type" type="hidden" value={product.get('type')}></input>
    </form>
  );
};

export default Form;
